@let showComponent = integration().integration?.authStatus === "valid";

@if (showComponent) {
    @let misUnits = missingUnits();
    @let misUnitsStr = misUnits ? misUnits.join(", ") : "";

    <h4 class="text-lg font-semibold">
        {{ "set_int_unit_mapping_heading" | translate }}
    </h4>
    <div class="mt-0 mb-4">
        {{ "set_int_unit_mapping_text" | translate: { integrationName: integration().name } }}
    </div>
    @if (misUnitsStr) {
        <div class="mb-2">
            <p-message severity="warn" class="message-warn-orange">
                <span> {{ "set_int_add_unit" | translate: { missingUnits: misUnitsStr } }} </span>
            </p-message>
        </div>
    }
    <div data-testid="integration-unit-mapping" class="flex-1 min-h-0 mb-2">
        <p-table [value]="tableUnits" [scrollable]="true" scrollHeight="flex">
            <ng-template pTemplate="header">
                <tr>
                    <th class="w-[45%]">
                        {{ "settings_integration_unit_column" | translate }}
                    </th>
                    <th class="w-[45%]">
                        {{ "settings_integration_multiplier_column" | translate }}
                        <i
                            class="pi pi-info-circle mx-2"
                            pTooltip="{{ 'settings_integration_unit_manage_explanation' | translate }}"
                            tooltipStyleClass="wide-tooltip"
                        ></i>
                    </th>
                    <th class="w-[10%] min-w-16"></th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row>
                <tr [attr.data-testid]="'integration-unit-row-' + row.key">
                    <td>{{ row.key }}</td>
                    <td>{{ row.multiplier }}</td>
                    <td>
                        <p-button class="ml-2" severity="secondary" (click)="removeUnit(row.key)">
                            <i class="pi pi-minus"></i>
                        </p-button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr>
                    <td>
                        @if (units) {
                            <p-select
                                data-testid="integration-unit-select"
                                class="w-full"
                                [options]="unitSelectOptions"
                                [(ngModel)]="selectedUnit"
                                optionValue="name"
                                optionLabel="name"
                                appendTo="body"
                                (ngModelChange)="checkReady()"
                            />
                        } @else {
                            <input data-testid="integration-unit-input" class="w-full" pInputText [(ngModel)]="inputUnit" (ngModelChange)="checkReady()" />
                        }
                    </td>
                    <td>
                        <div class="w-full">
                            <input
                                data-testid="integration-unit-multiplier"
                                class="w-full"
                                pInputText
                                [(ngModel)]="inputMultiplier"
                                (ngModelChange)="checkReady()"
                                style="{{ inputMultiplierStyle }}"
                                placeholder="{{ 'settings_integration_unit_conversion_placeholder' | translate }}"
                            />
                        </div>
                    </td>
                    <td>
                        <p-button
                            data-testid="integration-unit-add"
                            class="ml-2"
                            severity="secondary"
                            (click)="addUnit()"
                            [disabled]="!readyToAdd"
                            [styleClass]="readyToAdd ? 'button-ready' : ''"
                        >
                            <i class="pi pi-plus"></i>
                        </p-button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
}
